import React, { useContext } from 'react';
import { loadImage } from '../../../../../lib/utils/utils';
import { StorefrontContext } from '../../../../../Context/StorefrontContext';
import AddImage from '../../../../../Assets/Add image.svg';
import { showToast } from '../../../../../Components/Toaster/Toaster';
import { v4 as uuidv4 } from 'uuid';

function ImageInput({ banner, image }) {
    const {
        carouselBanner,
        setCarouselBanner,
    } = useContext(StorefrontContext);

    async function handleImageChange(e) {
        const file = e.target.files[0];
        const bannerFound = carouselBanner.find(item => item.title === banner.title);

        if(file) {
            const img = await loadImage(file);
            if ((img.width > 1080 || img.height > 1080) || (img.width/img.height !== 1)) {
                showToast('Please select image of resolution 1080*1080', 'warning');
            }
            else {
                const selectedImage = {
                    id: image.id ? image.id : uuidv4(),
                    url: img.src,
                    file: file,
                }

                setCarouselBanner((prevCarouselBanner) =>
                    prevCarouselBanner.map((item) =>
                        item.title === bannerFound.title
                            ? { ...item, image: selectedImage } 
                            : item
                    )
                );
            }
        }

        e.target.value = null;
    }

    return (
        <div className='flex flex-col gap-2'>
            <p className='font-medium text-[14px] leading-6 text-[#121212]'>Image <span className='text-[12px] text-[#666666]'>&#40;1080px * 1080px&#41;</span></p>

            <div className="flex items-center gap-3">
                {
                    image.url ? 
                    <div className="size-[100px] rounded-lg overflow-hidden">
                        <img className='size-full' src={image.url} alt="" />
                    </div> : 
                    <label htmlFor="carousel-image" className="cursor-pointer size-[100px] rounded-lg overflow-hidden bg-[#666666] flex items-center justify-center">
                        <img className='size-1/2' src={AddImage} alt="" />
                    </label>
                }

                <input 
                    id='carousel-image' 
                    name='carousel-image' 
                    className='hidden'
                    type="file" 
                    accept='image/*' 
                    onChange={handleImageChange} 
                />

                <label htmlFor='carousel-image' className='outline-none px-4 py-[6px] rounded-md bg-primaryColor hover:bg-primaryAccent font-semibold text-[12px] leading-6 text-buttonText cursor-pointer'>Change Image</label>
            </div>
        </div>
    );
}

export default ImageInput;
